import { boot } from 'quasar/wrappers';
import { Notify } from 'quasar';

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files

const defaultOptions = {
  position: 'top-right',
  multiLine: true,
  group: false,
  html: true,
  progress: true,
  attrs: {
    style: 'min-width: 300px; max-width: 600px',
  },
};

export default boot(async (/* { app, router, ... } */) => {
  Notify.registerType('app-info', {
    ...defaultOptions,
    icon: 'notifications',
    color: 'blue-2',
    textColor: 'black',
  });

  Notify.registerType('app-warning', {
    ...defaultOptions,
    icon: 'warning',
    color: 'orange-2',
    textColor: 'black',
  });

  Notify.registerType('app-error', {
    ...defaultOptions,
    icon: 'error',
    progress: false,
    color: 'red-2',
    textColor: 'black',
    timeout: 0,
  });

  Notify.registerType('app-task', {
    ...defaultOptions,
    icon: 'task',
    progress: false,
    color: 'green-2',
    textColor: 'black',
    timeout: 0,
  });

  Notify.registerType('app-export', {
    ...defaultOptions,
    icon: 'file_download',
    progress: false,
    color: 'green-2',
    textColor: 'black',
    timeout: 0,
  });
});
